var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1953 18.375C22.1953 17.248 23.11 16.3333 24.237 16.3333H37.6256C38.7526 16.3333 39.6673 17.248 39.6673 18.375V31.7893C39.6673 32.3308 39.4522 32.8501 39.0693 33.233C38.6864 33.6159 38.1671 33.831 37.6256 33.831H24.237C23.6955 33.831 23.1762 33.6159 22.7933 33.233C22.4104 32.8501 22.1953 32.3308 22.1953 31.7893V18.375V18.375ZM24.237 18.0833C24.1596 18.0833 24.0854 18.1141 24.0307 18.1688C23.976 18.2235 23.9453 18.2976 23.9453 18.375V31.7893C23.9453 31.9515 24.076 32.081 24.237 32.081H37.6256C37.703 32.081 37.7772 32.0503 37.8319 31.9956C37.8866 31.9409 37.9173 31.8667 37.9173 31.7893V18.375C37.9173 18.2976 37.8866 18.2235 37.8319 18.1688C37.7772 18.1141 37.703 18.0833 37.6256 18.0833H24.237V18.0833Z",
    fill: "#0F314D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3281 26.5405C16.328 26.2723 16.3807 26.0067 16.4832 25.7588C16.5857 25.511 16.7361 25.2858 16.9257 25.0961C17.1153 24.9064 17.3404 24.7559 17.5882 24.6532C17.836 24.5505 18.1016 24.4977 18.3698 24.4977H20.1256C20.3577 24.4977 20.5802 24.5899 20.7443 24.7539C20.9084 24.918 21.0006 25.1406 21.0006 25.3727C21.0006 25.6047 20.9084 25.8273 20.7443 25.9914C20.5802 26.1555 20.3577 26.2477 20.1256 26.2477H18.3698C18.2924 26.2477 18.2183 26.2784 18.1636 26.3331C18.1089 26.3878 18.0781 26.462 18.0781 26.5393L18.084 37.625C18.084 37.786 18.2135 37.9167 18.3756 37.9167H29.459C29.5363 37.9167 29.6105 37.8859 29.6652 37.8312C29.7199 37.7765 29.7506 37.7024 29.7506 37.625V35.8633C29.7506 35.6313 29.8428 35.4087 30.0069 35.2446C30.171 35.0805 30.3936 34.9883 30.6256 34.9883C30.8577 34.9883 31.0802 35.0805 31.2443 35.2446C31.4084 35.4087 31.5006 35.6313 31.5006 35.8633V37.625C31.5006 38.1665 31.2855 38.6858 30.9026 39.0687C30.5197 39.4516 30.0004 39.6667 29.459 39.6667H18.3756C17.8341 39.6667 17.3148 39.4516 16.9319 39.0687C16.5491 38.6858 16.334 38.1665 16.334 37.625L16.3281 26.5405Z",
    fill: "#0F314D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.834 21V29",
    stroke: "#0F314D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.834 24.9996C31.7158 25.1974 29.9511 25.2269 26.834 24.9996",
    stroke: "#0F314D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicationBlue);
export default __webpack_public_path__ + "static/media/duplicationBlue.81aaba7162a41b7ad53dc264ee339a0c.svg";
export { ForwardRef as ReactComponent };